import { Link, styled, Typography } from "@material-ui/core";

export const TTHTExploreContentWrapper = styled("div")(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  display: "flex",

  "& > div": {
    width: "25%",
  },

  [`${theme.breakpoints.down("sm")}`]: {
    "& > div": {
      width: "33%",
    },
  },

  [`${theme.breakpoints.down("xs")}`]: {
    "& > div": {
      width: "50%",
    },
  },
}));

export const TTHTExploreItemDescription = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontSize: theme.typography.body2.fontSize,
}));

export const TTHTExploreItemTitle = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/Explore/TTHTExploreSection.styled.js